<template>
    <div class="form_wrap zeb_register">        
        <div class="form_box ragister">
            <div class="form_inner">
                <h2>ZEB 제조사 등록 신청</h2>
                <form @submit.prevent="submitForm">
                    <input type="hidden" name="user_id" id="user_id" v-model="form.user_id">
                    <div class="inp_flx">
                        <div class="row">
                            <div class="inp">
                                <label for="company">회사명 <span class="red_f">*</span></label>
                                <input type="text" id="company" v-model="form.company" placeholder="회사명을 입력해주세요" required>
                            </div>
                            <div class="inp">
                                <label for="url">회사홈페이지</label>
                                <input type="text" id="url" v-model="form.url" placeholder="URL을 입력해주세요">
                            </div>
                        </div>
                        <div class="row">
                            <div class="inp">
                                <label for="type">유형선택</label>
                                <select name="type" id="type" v-model="form.type" class="zeb_regi_select">
                                     <option value="1">BIPV모듈</option>
                                     <option value="2">단열재 제품</option>
                                     <option value="3">시공사</option>
                                     <option value="4">모니터링/유지관리 기술</option>
                                </select>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="inp">
                                <label>로고 파일</label>
                                <div class="up_area" @dragover.prevent @drop.prevent="handleDrop($event, 'img_path')" @click="triggerFile('img_path')">
                                    <img v-if="!previews.img_path" src="/img/imgfile.4c74f9bc.svg" alt="">
                                    <span v-if="!previews.img_path">이미지를 드래그해서 드롭해주세요.</span>
                                    <img v-if="previews.img_path" :src="previews.img_path" class="preview-img" />
                                </div>
                                <input type="file" ref="img_path" hidden accept="image/*" @change="handleFileSelect($event, 'img_path')">
                            </div>     
                            <div class="inp">
                                <label>슬라이드1</label>    
                                <div class="up_area" @dragover.prevent @drop.prevent="handleDrop($event, 'slide1')" @click="triggerFile('slide1')">
                                    <img v-if="!previews.slide1" src="/img/imgfile.4c74f9bc.svg" alt="">
                                    <span v-if="!previews.slide1">이미지를 드래그해서 드롭해주세요.</span>
                                    <img v-if="previews.slide1" :src="previews.slide1" class="preview-img" />
                                </div>
                                <input type="file" ref="slide1" hidden accept="image/*" @change="handleFileSelect($event, 'slide1')">
                            </div>
                        </div>

                        <div class="row">
                            <div class="inp">
                                <label>슬라이드2</label>
                                <div class="up_area" @dragover.prevent @drop.prevent="handleDrop($event, 'slide2')" @click="triggerFile('slide2')">
                                    <img v-if="!previews.slide2" src="/img/imgfile.4c74f9bc.svg" alt="">
                                    <span v-if="!previews.slide2">이미지를 드래그해서 드롭해주세요.</span>
                                    <img v-if="previews.slide2" :src="previews.slide2" class="preview-img" />
                                </div>
                                <input type="file" ref="slide2" hidden accept="image/*" @change="handleFileSelect($event, 'slide2')">
                            </div> 
                            <div class="inp">
                                <label>슬라이드3</label>
                                <div class="up_area" @dragover.prevent @drop.prevent="handleDrop($event, 'slide3')" @click="triggerFile('slide3')">
                                    <img v-if="!previews.slide3" src="/img/imgfile.4c74f9bc.svg" alt="">
                                    <span v-if="!previews.slide3">이미지를 드래그해서 드롭해주세요.</span>
                                    <img v-if="previews.slide3" :src="previews.slide3" class="preview-img" />
                                </div>
                                <input type="file" ref="slide3" hidden accept="image/*" @change="handleFileSelect($event, 'slide3')">
                            </div> 
                        </div>

                        <div class="row">
                            <div class="inp">
                                <label>슬라이드4</label>
                                <div class="up_area" @dragover.prevent @drop.prevent="handleDrop($event, 'slide4')" @click="triggerFile('slide4')">
                                    <img v-if="!previews.slide4" src="/img/imgfile.4c74f9bc.svg" alt="">
                                    <span v-if="!previews.slide4">이미지를 드래그해서 드롭해주세요.</span>
                                    <img v-if="previews.slide4" :src="previews.slide4" class="preview-img" />
                                </div>
                                <input type="file" ref="slide4" hidden accept="image/*" @change="handleFileSelect($event, 'slide4')">
                            </div> 
                            <div class="inp">
                                <label>슬라이드5</label>
                                <div class="up_area" @dragover.prevent @drop.prevent="handleDrop($event, 'slide5')" @click="triggerFile('slide5')">
                                    <img v-if="!previews.slide5" src="/img/imgfile.4c74f9bc.svg" alt="">
                                    <span v-if="!previews.slide5">이미지를 드래그해서 드롭해주세요.</span>
                                    <img v-if="previews.slide5" :src="previews.slide5" class="preview-img" />
                                </div>
                                <input type="file" ref="slide5" hidden accept="image/*" @change="handleFileSelect($event, 'slide5')">
                            </div> 
                        </div>

                        <div class="row">
                            <div class="inp">
                                <label>카탈로그</label>
                                <div class="up_area" @dragover.prevent @drop.prevent="handleDrop($event, 'catalog')" @click="triggerFile('catalog')">
                                    <span class="icon material-symbols-outlined zebfile">upload</span>
                                    <span v-if="!form.catalog">파일을 드래그해서 드롭해주세요.</span>
                                    <span v-else style="color:#007bff; font-weight:bold;">{{ form.catalog.name }} (선택됨)</span>
                                </div>
                                <input type="file" ref="catalog" hidden accept="application/pdf" @change="handleFileSelect($event, 'catalog')">
                            </div>                      
                        </div>
                    </div>
                    <div class="btn mt20">
                        <button class="buttn" type="button" @click="$router.back()">취소</button>
                        <button class="buttn" type="submit">신청하기</button>
                    </div>
                </form>
            </div>
        </div>    
    </div>
</template>

<script>
import api from '@/api'

export default {
    name: 'ZebRegister',
    data() {
      return {
        isLoggedIn: false,
        user: null,
        previews: {
          img_path: null, slide1: null, slide2: null, slide3: null, slide4: null, slide5: null
        },
        form: {
          user_id: null,
          company: "",
          type: 1,
          url: "",
          img_path: null,
          slide1: null, slide2: null, slide3: null, slide4: null, slide5: null,
          catalog: null
        }
      }
    },
    async mounted() {
      await this.checkAuth();

      if (!this.isLoggedIn) {
        alert('로그인이 필요한 서비스입니다.');
        history.back();
        return;
      }

      // 로그인 사용자 ID 세팅
      this.form.user_id = this.user.id;

      // query.type 이 있으면 select 값 결정
      const qType = Number(this.$route.query.type);
      if ([1, 2, 3, 4].includes(qType)) {
        this.form.type = qType;
      }
    },
    methods: {
        triggerFile(refName) {
            this.$refs[refName].click();
        },
        handleFileSelect(event, field) {
            this.processFile(event.target.files[0], field);
        },
        handleDrop(event, field) {
            this.processFile(event.dataTransfer.files[0], field);
        },
        processFile(file, field) {
            if (!file) return;

            // 파일 형식 체크
            if (field === 'catalog') {
                if (file.type !== 'application/pdf') {
                    alert('카탈로그는 PDF 파일만 가능합니다.');
                    return;
                }
            } else {
                if (!file.type.startsWith('image/')) {
                    alert('이미지 파일만 업로드 가능합니다.');
                    return;
                }
                // 이미지 미리보기 URL 생성
                this.previews[field] = URL.createObjectURL(file);
            }
            this.form[field] = file;
        },
        async checkAuth() {
            try {    
              const res = await api.get('/admin/auth_check', { withCredentials: true });
              if (res.data.logged_in) {
                this.isLoggedIn = true;
                this.user = res.data.user;
              } else {
                this.isLoggedIn = false;
                this.user = null;
              }
            } catch (e) {
              this.isLoggedIn = false;
              this.user = null;
            }
        },
        async submitForm() {
            if (!this.form.company) {
                alert('회사명을 입력해주세요.');
                return;
            }

            const formData = new FormData();
            // 텍스트 필드 추가
            formData.append('company', this.form.company);
            formData.append('type', this.form.type);
            formData.append('url', this.form.url);

            // 파일 필드 추가 (값이 있는 것만)
            const fields = ['img_path', 'slide1', 'slide2', 'slide3', 'slide4', 'slide5', 'catalog'];
            fields.forEach(f => {
                if (this.form[f]) formData.append(f, this.form[f]);
            });

            try {
                const res = await api.post('/admin/zeb_company_store', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                if (res.data) {
                    alert('신청이 완료되었습니다.');
                    this.$router.push('/inquire_history');
                }
            } catch (e) {
                alert('저장 중 오류가 발생했습니다.');
            }
        }
    }
}
</script>

<style scoped>
.preview-img {
    max-width: 100%;
    max-height: 150px;
    object-fit: contain;
}
</style>